import { hasNoValue } from '../../util';

export const fileSizeAllowed = (file: File, maxAllowedSize: number): boolean =>
  hasNoValue(maxAllowedSize) || file.size <= maxAllowedSize;
